import { useCallback, useEffect, useState } from 'react';
import consultationExamOrderService from '../../../services/consultationExamOrderService';
import consultationCareReferralService from '../../../services/consultationCareReferralService';
import consultationRestDayService from '../../../services/consultationRestDayService';
import consultationService from '../../../services/consultationService';
import { parseExamOrdersResponse } from '../utils/examOrderFormat';
import { parseCareReferralsResponse } from '../utils/careReferralFormat';

const EMPTY_COUNTS = {
  exams: 0,
  referrals: 0,
  rest: 0,
  nursing: 0
};

function countRestDays(data) {
  if (!data || data.status === 'CANCELLED') return 0;
  return data.days_count > 0 ? 1 : 0;
}

function countNursingActs(data) {
  if (!data) return 0;
  const care = Array.isArray(data.careActions) ? data.careActions.length : 0;
  const tests = Array.isArray(data.testResults) ? data.testResults.length : 0;
  const vitals = Array.isArray(data.vitals) ? data.vitals.length : 0;
  const vaccines = Array.isArray(data.vaccinations) ? data.vaccinations.length : 0;
  return care + tests + vitals + vaccines;
}

/**
 * Compteurs légers pour les badges des modules complémentaires de consultation.
 */
export default function useConsultationActModuleCounts(consultationId, refreshKey = 0, siteId = '') {
  const [counts, setCounts] = useState(EMPTY_COUNTS);
  const [loading, setLoading] = useState(false);

  const refresh = useCallback(async () => {
    if (!consultationId) {
      setCounts(EMPTY_COUNTS);
      return;
    }
    setLoading(true);
    try {
      const [examsRes, referralsRes, restRes, nursingRes] = await Promise.all([
        consultationExamOrderService.list(consultationId),
        consultationCareReferralService.list(consultationId),
        consultationRestDayService.get(consultationId),
        consultationService.getNursingTimeline(consultationId, {
          site_id: siteId
        })
      ]);

      const exams = parseExamOrdersResponse(examsRes).orders.length;
      const referrals = parseCareReferralsResponse(referralsRes).referrals.length;
      const rest = countRestDays(restRes?.success ? restRes.data : null);
      const nursingCount = countNursingActs(nursingRes?.success ? nursingRes.data : null);

      setCounts({ exams, referrals, rest, nursing: nursingCount });
    } catch {
      setCounts(EMPTY_COUNTS);
    } finally {
      setLoading(false);
    }
  }, [consultationId, siteId]);

  useEffect(() => {
    refresh();
  }, [refresh, refreshKey]);

  return { counts, loading, refresh };
}
